import { useStructureContext } from "../../../context/StructureContext";
import { headerMovements } from "../../../data/admin";
import StdTable from "./StdTable";

export default function ItemMoveBox() {
  const { type, searchValues, section, printArea } = useStructureContext();

  return "FECMOV" in searchValues[section.id] ? (
    <div ref={printArea} className="listBox">
      <StdTable
        type={type}
        style={{ width: "100%" }}
        header={headerMovements}
        data={
          "results" in searchValues[section.id]
            ? searchValues[section.id].results
            : []
        }
        className="listTableRow"
      />
    </div>
  ) : (
    <></>
  );
}
